import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import type { ComponentProps } from 'react';
import React from 'react';

import { VitrinsFilters } from 'features/VitrinsFilters';
import { VitrinsOffersCards } from 'features/VitrinsOffers';

import { VITRINS_OFFERS_TEXTS } from 'widgets/VitrinsOffers/ui/VitrinsOffers.texts';

type Props = {
  title?: string;
  isGrayBackground?: boolean;
  onChangeFilter?: ComponentProps<typeof VitrinsFilters>['onChangeFilter'];
  submitButtonText?: string;
  onOfferSubmit?: ComponentProps<typeof VitrinsOffersCards>['onOfferSubmit'];
};

export const VitrinsOffers: FC<Props> = (props) => {
  const { title, isGrayBackground, onChangeFilter, submitButtonText, onOfferSubmit } = props;
  const isMobile = useIsMobile();

  return (
    <Space
      direction="vertical"
      size={16}
    >
      <Typography.Heading level={3}>{title || VITRINS_OFFERS_TEXTS.TITLE}</Typography.Heading>
      <Space
        direction="vertical"
        size={isMobile ? 16 : 24}
      >
        <VitrinsFilters
          isGrayBackground={isGrayBackground}
          onChangeFilter={onChangeFilter}
        />
        <VitrinsOffersCards
          isGrayCards={isGrayBackground}
          submitButtonText={submitButtonText}
          onOfferSubmit={onOfferSubmit}
          summaryItemsCount={4}
        />
      </Space>
    </Space>
  );
};
